import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="backoffice-loading">
        <div className="loading-spinner"></div>
        <p>A verificar autenticação...</p>
      </div>
    );
  }

  if (!isAuthenticated || !user?.isStaff) {
    return <Navigate to="/backoffice/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
